module.exports = __webpack_public_path__ + "img/v4_liquidationPositionDetail.11be2ae7.png";